import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/HowItWorks.css';

const Roasters = () => {
  const steps = [
    {
      id: '01',
      title: 'Shop with our partners',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/owner3.png',
    },
    {
      id: '02',
      title: 'Pick your delivery spot',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/roastertaste.png',
    },
    {
      id: '03',
      title: 'Get drone delivery',
      image: 'https://storage.googleapis.com/app_darkendimg/openkoffie/b_1.png',
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section className="how-it-works-section" id="how-it-works">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="#how-it-works" className="section-link">Roast</a>
          <h2 className="news-title">For Roasters</h2>
        </motion.div>

        <motion.div 
  className="steps-container"
  variants={containerVariants}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  {steps.map((step) => (
    <motion.div 
      key={step.id} 
      className="step-card"
      variants={itemVariants}
      style={{ backgroundImage: `url(${step.image})` }}
    >
      <div className="step-overlay">
        <div className="step-number">{step.id}</div>
        <h3 className="step-title">{step.title}</h3>
      </div>
    </motion.div>
  ))}
</motion.div>



        
      </div>
    </section>
  );
};

export default Roasters;
